/*
 * @Description: 按钮权限指令
 * @Author: mdb
 * @Date: 2022-08-25 12:21:30
 * @LastEditTime: 2023-04-19 15:08:26
 * @LastEditors: mdb
 */
import type { Directive, DirectiveBinding } from 'vue'
import { usePermissionStore } from '@/stores/permission'

function isAuth(el: Element, binding: DirectiveBinding) {
  // value 获取用户使用自定义指令绑定的内容
  const value = binding.value
  // 给按钮添加埋点ID
  if (!el.id && value) el.id = value

  if (location.host === 'dev-dc.eminxing.com') return

  // 获取用户所有的权限按钮
  const permissionStore = usePermissionStore()
  const permissionBtn = permissionStore.permission

  // 判断用户是否正确使用自定义指令
  if (value && typeof value === 'string') {
    if (!permissionBtn.includes(value)) {
      el.parentNode?.removeChild(el)
    }
  } else {
    el.parentNode?.removeChild(el)
    console.error('请使用 v-permission 指令,并传入正确的权限按钮名称,如：v-permission="\'add_btn\'"')
  }
}

const permission: Directive = {
  created(el: Element, binding: DirectiveBinding) {
    isAuth(el, binding)
  },
  mounted(el: Element, binding: DirectiveBinding) {
    isAuth(el, binding)
  },
  updated(el: Element, binding: DirectiveBinding) {
    isAuth(el, binding)
  }
}

export default permission
